import React, { useEffect, useState } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import axios from "axios";
import BASE_URL from "../../config/config";
const IMAGE_BASE_URL = `${BASE_URL}/employees/view/`;
const CASE_DETAIL_API = `${BASE_URL}/case-studies/title/`;

const CaseDetail = () => {
  const { slug } = useParams();
  const location = useLocation();
  const [caseDetail, setCaseDetail] = useState(null);
  const [loading, setLoading] = useState(true);

  const toSlug = (text) =>
    text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-");

  useEffect(() => {
    const fetchCaseDetail = async () => {
      try {
        let title = location.state?.title;

        // If title is not passed via navigation, find it from the list
        if (!title) {
          const listRes = await axios.get(`${BASE_URL}/case-studies/list`);
          if (listRes.data.success) {
            const matched = listRes.data.data.find(
              (item) => toSlug(item.title) === slug
            );
            title = matched?.title;
          }
        }

        if (title) {
          const response = await axios.get(`${CASE_DETAIL_API}${title}`);
          if (response.data?.success) {
            setCaseDetail(response.data.data);
          } else {
            setCaseDetail(null);
          }
        } else {
          setCaseDetail(null);
        }
      } catch (error) {
        console.error("Failed to fetch case study:", error);
        setCaseDetail(null);
      } finally {
        setLoading(false);
      }
    };

    fetchCaseDetail();
  }, [slug, location.state]);

  if (loading) return <div className="p-10 text-center">Loading...</div>;
  if (!caseDetail)
    return <div className="p-10 text-center">No case study found.</div>;

  return (
    <>
      <div className="relative w-full h-[60vh] md:h-[70vh] bg-black">
        <div className="absolute inset-0">
          <img
            src={`${IMAGE_BASE_URL}${caseDetail.imagePreview}`}
            alt={caseDetail.title}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-35"></div>
        </div>
        <div className="relative z-10 flex flex-col justify-center items-start h-full px-6 md:px-16 text-white">
          <h1 className="text-3xl md:text-4xl  capitalize font-bold mb-4">
            {caseDetail.title}
          </h1>
          <div className="flex items-center space-x-2 text-sm md:text-base">
            <Link to="/" className="text-white hover:underline font-bold">
              Home
            </Link>
            <span className="text-red-500">●</span>
            <span className="text-gray-300">Case Study</span>
          </div>
        </div>
      </div>

      {caseDetail.quillEntries && caseDetail.quillEntries.length > 0 && (
        <div className="max-w-6xl mx-auto px-4 py-8">
          {caseDetail.quillEntries.map((entry, index) => (
            <div key={index} className="mb-5">
              <h2 className="md:text-2xl text-xl font-semibold text-main1">
                {entry.heading}
              </h2>
              <div
                className="text-gray-800 md:text-base text-base leading-relaxed"
                dangerouslySetInnerHTML={{ __html: entry.content }}
              />
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default CaseDetail;
